module.exports = __webpack_public_path__ + "media/images/wedding/17-1195141d3025543259dd2d28f8013a33.jpg";